import axios from 'axios'

export const apiFetcher = async (url: string, options: any = {}) => {
  const sanitizedUrl = url
    .split('/')
    .filter((v) => !!v)
    .join('/')

  const { headers = {}, ...config } = options

  try {
    let path = process.env.CT_CALCULATOR_API

    if (typeof window === 'undefined') {
      path = process.env.NEXT_PUBLIC_HOST_URL + path
    }

    const response = await axios(
      url?.includes('http') ? url : `${path}/${sanitizedUrl}`,
      {
        headers,
        ...config
      }
    )

    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
